import '../features/header';
import '../features/burger';
import '../features/giftsGallery';
import '../features/goToTopButton';
